import { Link, useNavigate } from "react-router-dom";
// import VideoCall from "./consultant/view/videoCall";

import { lazy, useCallback, useEffect, useState } from "react";
import { cn } from "../shared/utils";
import { createRoom, sendSms } from "../lib/api";
import { useStore } from "../store";

const VideoCall = lazy(()=>import("./consultant/view/videoCall"))

const VideoCallPage = () => {
  let navigate = useNavigate();
  const [isScheduled, setScheduled] = useState(false);
  const [roomUrl, setRoomUrl] = useState(null);
  const [isJoin, setIsJoin] = useState(false);

  const [apiError, setApiError] = useState(false);
  const [isLoading, setLoader] = useState(false);

  // const [patientInfo, setPatientInfo] = useState(null);

  const patientInfo = useStore((state) => state.patient);

  useEffect(() => {
    setLoader(true);
    console.log("card");
    const dr = sessionStorage.getItem("selectedDoctor")
      ? JSON.parse(sessionStorage.getItem("selectedDoctor"))
      : null;
    const time = sessionStorage.getItem("time");
    const date = sessionStorage.getItem("date");


    console.log(dr, time, date);
    // if (dr && time && date) {
    //   setScheduled(true);
    //   setCurrentDoctor(dr);
    //   setTime(time);
    //   setDate(date);
    //   startCall();
    // }

      startCall();
    
    

  }, []);

  const createCall = useCallback(() => {
    return createRoom()
      .then((room) => room.url)
      .catch((error) => {
        console.error("Error creating room", error);
        setRoomUrl(null);
        setApiError(true);
      });
  }, []);

  const handleLeft = () => {
    console.log("left");
    setRoomUrl(null);
    sessionStorage.removeItem('date')
    sessionStorage.removeItem('time')
    sessionStorage.removeItem('selectedDoctor')
    sessionStorage.removeItem('selectedAppointment')
    navigate("/dashboard");
  };
  const handleJoin = () => {
    console.log("join");
    setIsJoin(true);
  };

  const renderApp = () => {
    // If something goes wrong with creating the room.
    if (apiError) {
      return (
        <div className="api-error">
          <h1>Error</h1>
          <p>
            Room could not be created. :)
          </p>
        </div>
      );
    }

    // No API errors, we passed the hair check, and we've joined the call? Then show the call.
    if (roomUrl) {
      console.log(roomUrl, "room");
      return (
        <VideoCall
          roomUrl={roomUrl}
          onleftMeeting={handleLeft}
          user={patientInfo}
          onJoiningMeeting={handleJoin}
        />
      );
    }

    // The default view is the HomeScreen, from where we start the demo.
    return <></>;
  };

  const startCall = async() => {
    setLoader(true);
    const selectedAppointment = sessionStorage.getItem("selectedAppointment")
      ? JSON.parse(sessionStorage.getItem("selectedAppointment"))
      : null;
    const url = selectedAppointment?.virtual_room?.url
      if(url){
       const phone = selectedAppointment?.user?.contact?.find(
          (contact) => contact.type === "phone"
        )?.value;
        setRoomUrl(url);
        const payload = {
          phone: phone,
          message: `Hi Doctor,  ${patientInfo?.profile?.first_name} ${patientInfo?.profile?.middle_name} ${patientInfo?.profile?.last_name} has joined for the video consultation with you. Please start the call: ${url} - PROGNOSIS`,
        };
        const sms = await sendSms(selectedAppointment?.id);
        if (sms.isSuccess ) {
          setLoader(false);
        }
        return
      }
    // createCall().then(async (url) => {
    //   setLoader(false);
    //   setRoomUrl(url);
    //   console.log(url);
    //   const patientInfo = sessionStorage.getItem("patientdata")
    //   ? JSON.parse(sessionStorage.getItem("patientdata"))
    //   : null;
    //   const currentDoctor = sessionStorage.getItem("selectedDoctor")
    //   ? JSON.parse(sessionStorage.getItem("selectedDoctor"))
    //   : null;
    //   const payload = {
    //     phone: '+919544681009'|| currentDoctor?.phone,
    //     message: `Hi Doctor,  ${patientInfo?.profile?.first_name} ${patientInfo?.profile?.middle_name} ${patientInfo?.profile?.last_name} has joined for the video consultation with you. Please start the call: ${url} - PROGNOSIS`,
    //   };
    //   const sms = await sendSms(payload);
    //   if (sms.statusCode == "200") {
    //     setLoader(false);
    //   }
    // });
  };

  return (
    <div className="bg-gray-50 min-sh-screen">
      {!isJoin && (
        <div className="flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 ">
          <div>
            <Link className="flex" to="/Dashboard">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-sm">Back</h4>
              </div>
            </Link>
          </div>
        </div>
      )}
      <div
        className={cn(
          " flex-1 overflow-scroll hideScroll   flex flex-col md:flex-row   gap-4",
          !isJoin && "p-4 pt-16 "
        )}
      >
        {isLoading && (
          <div className="sh-screen w-full flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
            <div className="flex flex-auto flex-col justify-center items-center p-4 md:p-5">
              <div className="flex justify-center">
                <div
                  className="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
                  role="status"
                  aria-label="loading"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {!isLoading && roomUrl && <div className="w-full">{renderApp()} </div>}
      </div>
    </div>
  );
};

export default VideoCallPage;
